var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/** parse JSON string，同时 catch 错误 */
export var safeParse = function (content, defaultValue) {
    if (defaultValue === void 0) { defaultValue = {}; }
    try {
        return JSON.parse(content);
    }
    catch (_a) {
        return defaultValue;
    }
};
/** 编码 */
export var safeEncodeURIComponent = function (content) {
    try {
        return encodeURIComponent(content);
    }
    catch (_a) {
        return content !== null && content !== void 0 ? content : '';
    }
};
/** 解码 */
export var safeDecodeURIComponent = function (content) {
    try {
        return decodeURIComponent(content);
    }
    catch (_a) {
        return content !== null && content !== void 0 ? content : '';
    }
};
export var get = function (value, keys) {
    if (keys === void 0) { keys = []; }
    var curValue = value;
    var depKeys = __spreadArray([], keys, true);
    while (curValue !== undefined && depKeys.length) {
        curValue = curValue === null || curValue === void 0 ? void 0 : curValue[depKeys.shift()];
    }
    return curValue;
};
